import React, { useMemo } from 'react';
import { Tooltip, Icon, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Colors from '../../../../../themes/Colors';
import { contentFormatKey } from '../../../../../services/contents';

const { Text } = Typography;

const ContentSpecificationAlert = ({
  displays,
  customContentsFiltered,
  styleCustom,
  listContents,
  listResolutionWithContent,
  hasText = false
}) => {
  const { t } = useTranslation();

  const alertSpecification = useMemo(() => {
    if (displays && displays.length === 0) return false;
    if (listResolutionWithContent && listResolutionWithContent.length === 0) return false;

    if (displays) {
      return displays.some(display => {
        if (customContentsFiltered && !listContents) {
          const customContentAux = customContentsFiltered.filter(cc => cc.displayId === display.id);
          const activeAlert = !customContentAux.some(
            cc => display.format_settings[contentFormatKey(cc.content.type)]
          );
          if (activeAlert) return true;
          return customContentAux.some(
            cc =>
              cc.content.type === 'video' &&
              Math.floor(cc.content.length / 1000) * 1000 > display.slot_length
          );
        }
        return false;
      });
    }

    if (listResolutionWithContent) {
      return listResolutionWithContent.some(resolution =>
        resolution.contentsDisplays.some(contentDisplay => {
          const content = resolution.contents.find(c => c.id === contentDisplay.contentId);
          const display = resolution.displays.find(d => d.id === contentDisplay.displayId);
          if (content && display) {
            return (
              !display.format_settings[contentFormatKey(content.type)] ||
              (content.type === 'video' &&
                Math.floor(content.length / 1000) * 1000 > display.slot_length)
            );
          }
          return false;
        })
      );
    }
  }, [listContents, customContentsFiltered, listResolutionWithContent]);

  const getTooltipMessage = () => {
    if (displays && displays.length === 1) {
      return t('Some content does not meet the specifications on this screen');
    }
    return t('Some content does not meet the specifications on one or more screens in this group');
  };

  return alertSpecification ? (
    <>
      <Tooltip placement="left" title={getTooltipMessage()}>
        <Icon
          style={
            styleCustom
              ? styleCustom
              : { fontSize: '20px', marginLeft: '10px', color: Colors.red, verticalAlign: 'bottom' }
          }
          type="warning"
        />
      </Tooltip>
      {hasText && (
        <Text style={{ color: Colors.textMuted, fontSize: '13px', fontStyle: 'italic' }}>
          {t('Some content does not meet the specifications on one or more screens')}
        </Text>
      )}
      <br />
    </>
  ) : null;
};

export default ContentSpecificationAlert;
